import moment from 'moment';

// De-para da forma de pagamento (FORM_PGT) que vem do SAP no formato
// "Q - CR - Empresa Emite-Boleto-San". Usamos a primeira letra (codigo) para
// mapear para um nome amigavel ao cliente em vez do texto descritivo cru.
const PAYMENT_METHOD_LABELS: Record<string, string> = {
  A: 'Boleto',
  B: 'Borderô',
  C: 'Cheque',
  D: 'Boleto',
  E: 'Espécie',
  F: 'Cheque à Vista',
  G: 'Cheque Pré-Datado',
  H: 'Carteira',
  I: 'Cartão de Crédito',
  J: 'Boleto',
  K: 'Cheque',
  L: 'Cartão de Débito',
  M: 'Vale Shop',
  N: 'Acerto Machine',
  O: 'Acordo',
  P: 'Boleto',
  Q: 'Boleto',
  R: 'Pix',
  S: 'Crédito CC Salário',
  T: 'TED',
  U: 'Baixa Manual',
  V: 'Boleto',
  W: 'Risco Sacado',
  X: 'Débito em Conta',
  Y: 'Pix',
};

/**
 * Converte o FORM_PGT cru no nome amigavel. Tags vazias do SAP chegam como []
 * (ou ausentes), por isso so processamos quando for string nao vazia. Codigo
 * desconhecido cai no texto original (sem o prefixo de codigo, se possivel).
 */
export const getPaymentMethodLabel = (formPgt?: unknown): string => {
  if (typeof formPgt !== 'string' || !formPgt.trim()) return '';
  const code = formPgt.trim().charAt(0).toUpperCase();
  return PAYMENT_METHOD_LABELS[code] ?? formPgt.trim();
};

/**
 * Formata a data provavel de entrega (DT_REMESSA, "YYYY-MM-DD") para
 * "DD/MM/YYYY". Retorna '' quando o valor nao e uma data string valida
 * (tags vazias do SAP chegam como [], que e truthy e quebraria o moment).
 */
export const formatDeliveryDate = (value?: unknown): string => {
  if (typeof value !== 'string' || !value.trim()) return '';
  const date = moment(value, 'YYYY-MM-DD');
  return date.isValid() ? date.format('DD/MM/YYYY') : '';
};
